import React from "react"
import PropTypes from "prop-types"

import "./index.less"
import { Input, Popover, Radio, Form } from "antd"
import { QuestionIcon } from "../../../../icons/svg/iconQuestion"
import { isModuleBySlug } from "../../../../utils/storage"
import { ENPS_NPS_SCALE } from "../../../../utils/constants"

export function EnpsForm(props) {
  const isEnpsScale = isModuleBySlug(ENPS_NPS_SCALE)

  const renderTextEnps = () => {
    return (
      <div className="TextEnps">
        {renderTextLeft()}
        {renderTextCenter()}
        {renderTextRight()}
      </div>
    )
  }

  const renderScaleEnps = () => {
    const { scaleEnps, onChangeScaleEnps, disabledFields } = props
    const options = [
      { label: "0 al 5", value: "5" },
      { label: "0 al 10", value: "10" },
    ]
    return (
      <div className="ScaleEnps">
        <strong className="ScaleEnps--title">Escala</strong>
        {renderPopoverScaleEnps()}
        <Radio.Group
          disabled={disabledFields}
          className="ScaleEnps--radio"
          options={options}
          onChange={(e) => onChangeScaleEnps(e.target.value)}
          value={scaleEnps}
          optionType="button"
        />
      </div>
    )
  }

  const renderPopoverScaleEnps = () => {
    return (
      <Popover
        placement="bottomLeft"
        align={{ offset: [-10, 0] }}
        content={
          <div style={{ width: 283, fontSize: 13 }}>
            <p>
              La pregunta <strong>NPS</strong> (Net Promoter Score) es un
              indicador que mide la fidelidad y el engagement de los
              colaboradores con su organización. Se basa en una pregunta en la
              que los colaboradores tienen que marcar del 0 al 5, o del 0 al 10,
              qué tanto recomendarían a la empresa como lugar de trabajo a sus
              amigos o familiares.
            </p>
            <span style={{ marginTop: 16 }}>
              *Solo es posible crear <strong>1 pregunta</strong> NPS por
              cuestionario.
            </span>
          </div>
        }
        overlayClassName="ScaleEnps--popover">
        <QuestionIcon />
      </Popover>
    )
  }

  const renderTextLeft = () => {
    const { disabledFields, enpsTextLeft, onChangeEnpsText } = props
    return (
      <div className="TextEnps__Item">
        <div className="TextEnps__Item--title">Texto extremo izquierdo*</div>
        <Form.Item
          name="text_enps_left"
          label=""
          rules={[
            {
              required: true,
            },
            {
              max: 30,
              message: "Este campo debe contener menos de 30 caracteres."
            }
          ]}>
          <div className="TextEnps__Item--input">
            <Input
              disabled={disabledFields}
              value={enpsTextLeft}
              placeholder="Totalmente en desacuerdo"
              onChange={(e) =>
                onChangeEnpsText({
                  typeText: "left",
                  valueChange: e.target.value,
                })
              }
            />
          </div>
        </Form.Item>
      </div>
    )
  }

  const renderTextCenter = () => {
    const { disabledFields, enpsTextCenter, onChangeEnpsText } = props
    return (
      <div className="TextEnps__Item" style={{ margin: "16px 0" }}>
        <div className="TextEnps__Item--title">Texto centro</div>
        <Form.Item name="text_enps_center" rules={[{ max: 30, message: "Este campo debe contener menos de 30 caracteres." }]}>
          <div className="TextEnps__Item--input">
            <Input
              disabled={disabledFields}
              value={enpsTextCenter}
              placeholder="Indiferente"
              onChange={(e) =>
                onChangeEnpsText({
                  typeText: "center",
                  valueChange: e.target.value,
                })
              }
            />
          </div>
        </Form.Item>
      </div>
    )
  }

  const renderTextRight = () => {
    const { disabledFields, enpsTextRight, onChangeEnpsText } = props
    return (
      <div className="TextEnps__Item">
        <div className="TextEnps__Item--title">Texto extremo derecho*</div>
        <Form.Item
          name="text_enps_right"
          label=""
          rules={[
            {
              required: true,
            },
            {
              max: 30,
              message: "Este campo debe contener menos de 30 caracteres."
            }
          ]}>
          <div className="TextEnps__Item--input">
            <Input
              disabled={disabledFields}
              value={enpsTextRight}
              placeholder="Totalmente de acuerdo"
              onChange={(e) =>
                onChangeEnpsText({
                  typeText: "right",
                  valueChange: e.target.value,
                })
              }
            />
          </div>
        </Form.Item>
      </div>
    )
  }

  return (
    <div className="EnpsForm">
      {isEnpsScale && renderScaleEnps()}
      {renderTextEnps()}
    </div>
  )
}

EnpsForm.propTypes = {
  disabledFields: PropTypes.bool,
  enpsTextLeft: PropTypes.string,
  enpsTextCenter: PropTypes.string,
  enpsTextRight: PropTypes.string,
  onChangeEnpsText: PropTypes.func,
  scaleEnps: PropTypes.string,
  onChangeScaleEnps: PropTypes.func,
}

export default EnpsForm
